import { render, staticRenderFns } from "./ModalTableTransfMerg.vue?vue&type=template&id=9c6e8468&"
import script from "./ModalTableTransfMerg.vue?vue&type=script&lang=js&"
export * from "./ModalTableTransfMerg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports